module.exports = __webpack_public_path__ + "static/shawna-friends-c0dc7372a2135059347ea3e4e635caac.jpg";